import { DomainEvent } from "@platform/event-bus/domain/model/domain-event.model";
import { CheckoutOrder } from '@platform/checkout/domain/models/checkout-order.model';

export interface CartOrderUnPaidPayload {
  order: CheckoutOrder;
}

export class CartOrderUnpaidEvent implements DomainEvent {
  readonly occurredAt = new Date();

  constructor(public readonly payload: CartOrderUnPaidPayload) {
  }
}
